import _ from 'lodash';

export const DEPARTMENTS = {
  CLIENT: 'client',
  HOUSEKEEPING: 'housekeeping',
  INSPECTION: 'inspection',
  MAINTENANCE: 'maintenance',
  PROPERTY: 'property',
  SCHEDULE: 'schedule',
};

export const DEPARTMENT_NAMES = {
  housekeeping: 'Cleaning',
  inspection: 'Inspection',
  maintenance: 'Maintenance',
};

/**
 * @type {Array}
 */
export const DEPARTMENT_OPTIONS = [
  { code: DEPARTMENTS.HOUSEKEEPING, name: 'Cleaning' },
  { code: DEPARTMENTS.INSPECTION, name: 'Inspection' },
  { code: DEPARTMENTS.MAINTENANCE, name: 'Maintenance' },
];

/**
 * @type {Object}
 */
export const DEPARTMENT_WORKERS = {
  housekeeping: 'Cleaners',
  inspection: 'Inspectors',
  maintenance: 'Maintenance',
};

export const departmentsArray = Object.values(DEPARTMENTS);

export const departmentsValuesArray = Object.keys(DEPARTMENT_NAMES);

export const getDepartmentsOptions = _.map(departmentsValuesArray, option => ({
  label: _.get(DEPARTMENT_NAMES, option),
  value: option,
}));

export const getUserDepartments = userAccess =>
  _.filter(departmentsArray, department => _.includes(userAccess, `${department}_create`));
